module.exports = __webpack_public_path__ + "img/feedback.d35a92e9.svg";